import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSlider from "./sections/HeroSlider";
import Fieldworkportfolio from "./sections/Fieldworkportfolio";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSlider />
      <Fieldworkportfolio />
      <Footer />
    </div>;
}